export default "<template>\n\n  <KButton\n    disabled\n    text=\"Raised Button\"\n  />\n\n</template>\n";